/**
 * Parametro della pagina di login con l'indirizzo da riaprire dopo l'accesso.
 * Lo imposta `UserGuard` quando un utente non autenticato apre una pagina
 * protetta (es. da un link condiviso da un collega).
 */
export const RETURN_URL_PARAM = 'returnUrl';

/**
 * Indirizzo di ritorno utilizzabile, oppure `null`.
 *
 * Il valore arriva dall'URL e chiunque può scriverlo: si accettano solo
 * percorsi interni all'applicazione. Sono esclusi gli indirizzi verso altri
 * siti (`https://…`, `//host`) e il login stesso, che riporterebbe l'utente
 * dove già si trova.
 */
export function returnUrlSicuro(valore: string | null | undefined): string | null {
  if (!valore) return null;
  if (!valore.startsWith('/') || valore.startsWith('//') || valore.startsWith('/\\')) return null;
  if (valore.split(/[?#]/)[0] === '/login') return null;
  return valore;
}
